import { render, staticRenderFns } from "./PlaceInfo.vue?vue&type=template&id=3e540183&"
import script from "./PlaceInfo.vue?vue&type=script&lang=js&"
export * from "./PlaceInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlaceInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports